import React, { useEffect, useRef, useState } from "react";
import { baseUrl } from '../../config.js'
import { Link, useNavigate, useParams } from 'react-router-dom'
import useToken from '../../useToken';

import './Host.css';

import Agregar from '../../img/Agregar.png';
import defaultAlmacen from '../../img/defaultAlmacen.png';
import PromoOdoo from './PromoOdoo.js';

const Host = ({selectAlmacen})=>{
	
	const {token} = useToken();
	const {idCompany} = useParams();
	const navigate = useNavigate();
	const [persona, setPersona] = useState({});
	const [almacenes, setAlamcenes] = useState([]);
	const [cantidades, setCantidades] = useState({});
	const [filtros, setFiltros] = useState({});
	const [vistaLista, setVistaLista] = useState(false);

	useEffect(()=>{
		if(token)
            getData();
	}, [token])

	const getData = async ()=>{
		console.log(idCompany)
		if(idCompany){
			const result = await fetch(baseUrl+"Company/"+idCompany,{
				headers:{
					'Content-Type': 'application/json',
					'Accept': 'application/json',
					'Authorization': `Bearer ${token}`,
				}
			})
			.then(response=>response.json())
			.then(json=>{
				console.log(json);
				return json;
			})
			.catch(error=>{
				console.error(error);
			})
			setPersona(result.data || []);
		}

		const result1 = await fetch(baseUrl+(idCompany ? 'Company/'+idCompany+'/Stores/' : 'Stores/User/'),{
			headers:{
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		if(result1?.success){
			setAlamcenes(result1.data || []);
		}
	}

	useEffect(()=>{
		const aux = {
			activos : 0,
			proceso: 0,
		}
		almacenes?.forEach(almacen=>{
			if(almacen.approved)
				aux["activos"]++;
			else
				aux["proceso"]++;
		})

		setCantidades(aux)
	}, [almacenes])

	if(selectAlmacen)
		return(
			<div className="personas-container">
				<div className="personas-header">
					<h2 style={{margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#1a1a1a'}}>Selecciona el Almacén</h2>
				</div>
				{almacenes.length === 0 &&
					<div className="no-empresas">
						<p>No tienes almacenes registrados</p>
					</div>
				}
				<div className="almacenes-grid">
					{almacenes.map(almacen=>{
						return(
							<Link data-tour="almacen-item-selector" to={'/host/gestion/publicaciones/'+almacen.idStore+'/nueva'} key={almacen.idStore} className="almacen-card">
								<div className="almacen-image">
									{almacen?.Photos.length!=0 && almacen?.Photos[0] &&
										<img src={almacen?.Photos[0].url} alt={almacen.name}/>
									}
									{almacen?.Photos.length === 0 &&
										<img src={defaultAlmacen} alt="Almacén predeterminado"/>
									}
								</div>
								<div className="almacen-info">
									<h3 className="almacen-nombre">{almacen.name}</h3>
									<span className={`almacen-status ${almacen.approved ? 'activo' : 'proceso'}`}>
										{almacen.approved ? 'Activo' : 'En Proceso'}
									</span>
								</div>
							</Link>
						)
					})
					}
				</div>
			</div>
		)
	else
		return(
			<div className="personas-container">
				<PromoOdoo/>
				{idCompany && persona.name &&
					<div className="pertenece">
						<h2>Almacenes de <b>{persona.name}</b></h2>
					</div>
				}
				
				<div className="personas-header">
					<div className="filter-section">
						<div className="view-toggle">
							<button 
								className={!vistaLista ? 'active' : ''} 
								onClick={() => setVistaLista(false)}
								title="Vista de cuadrícula"
							>
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
								<rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
								<rect x="11" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
								<rect x="2" y="11" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
								<rect x="11" y="11" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
							</svg>
						</button>
						<button 
							className={vistaLista ? 'active' : ''} 
							onClick={() => setVistaLista(true)}
							title="Vista de lista"
						>
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
								<path d="M6 4H16M6 9H16M6 14H16M2 4H3M2 9H3M2 14H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
							</svg>
						</button>
					</div>
					<div className="filter-pills">
						<button
							className={`filter-pill ${filtros?.status == undefined ? 'active' : ''}`}
							onClick={()=>{
								setFiltros({...filtros, status: undefined});
							}}
						>
							<span className="filter-label">Todos</span>
							<span className="filter-count">{almacenes?.length || 0}</span>
						</button>
						<button
							className={`filter-pill ${filtros?.status == 'activos' ? 'active' : ''}`}
							onClick={()=>{
								setFiltros({...filtros, status: 'activos'});
							}}
						>
							<span className="filter-label">Activos</span>
							<span className="filter-count">{cantidades?.activos || 0}</span>
						</button>
						<button
							className={`filter-pill ${filtros?.status == 'proceso' ? 'active' : ''}`}
							onClick={()=>{
								setFiltros({...filtros, status: 'proceso'});
							}}
						>
							<span className="filter-label">En Proceso</span>
							<span className="filter-count">{cantidades?.proceso || 0}</span>
						</button>
					</div>
				</div>
					
					<Link data-tour="btn-agregar-almacen" className="btn-agregar-empresa" to={idCompany ? 'nuevo' : '/host/gestion/almacenes/nuevo'}>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
							<path d="M10 5v10M5 10h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
						</svg>
						<span>Agregar Almacén</span>
					</Link>
				</div>

				<div className={vistaLista ? "almacenes-list" : "almacenes-grid"}>
					{almacenes.length === 0 &&
						<div className="no-empresas">
							<p>No hay almacenes para mostrar</p>
						</div>
					}
					{almacenes.map(almacen=>{
						if(!filtros.status || (filtros.status == 'activos' && almacen.approved) || (filtros.status == 'proceso' && !almacen.approved))
						return(
							<Link to={'/host/gestion/almacenes/'+almacen.idStore} key={almacen.idStore} className={vistaLista ? "almacen-list-item" : "almacen-card"}>
								<div className="almacen-image">
									{almacen?.Photos.length!=0 && almacen?.Photos[0] &&
										<img src={almacen?.Photos[0].url} alt={almacen.name}/>
									}
									{almacen?.Photos.length === 0 &&
										<img src={defaultAlmacen} alt="Almacén predeterminado"/>
									}
								</div>
								<div className="almacen-info">
									<h3 className="almacen-nombre">{almacen.name}</h3>
									<span className={`almacen-status ${almacen.approved ? 'activo' : 'proceso'}`}>
										{almacen.approved ? 'Activo' : 'En Proceso'}
									</span>
								</div>
							</Link>
						)
					})
					}
				</div>
			</div>
		);
}

export default Host;